import { initSubRoutes } from '../../../../utils/router';

const RoutesChangementMotDePasse = initSubRoutes({
    route: '/changement-mot-de-passe',
    subroutes: {},
    nom: 'Changement de mot de passe',
});

export default RoutesChangementMotDePasse;
